/**
 * Badge Styles
 * Size configurations for badge components
 */

export type BadgeSize = "xs" | "sm" | "md" | "lg";

interface BadgeSizeStyle {
  px: number;
  py: number;
  iconSize: number;
  fontSize: "2xs" | "xs" | "sm" | "md";
}

export const BADGE_SIZE_STYLES: Record<BadgeSize, BadgeSizeStyle> = {
  xs: { px: 1, py: 0.5, iconSize: 2.5, fontSize: "2xs" },
  sm: { px: 1.5, py: 0.5, iconSize: 3, fontSize: "xs" },
  md: { px: 2, py: 1, iconSize: 4, fontSize: "sm" },
  lg: { px: 2.5, py: 1.5, iconSize: 5, fontSize: "md" },
};

export const COUNT_BADGE_SIZE_STYLES: Record<BadgeSize, BadgeSizeStyle> = {
  xs: { px: 1, py: 0.5, iconSize: 2.5, fontSize: "2xs" },
  sm: { px: 1.5, py: 0.5, iconSize: 3, fontSize: "xs" },
  md: { px: 2, py: 0.5, iconSize: 3.5, fontSize: "sm" },
  lg: { px: 2.5, py: 0.5, iconSize: 4, fontSize: "md" },
};
